import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

const useTO = () => {
  const { leadId } = useParams();
  const values = useSelector((state) => state?.leads?.byIds?.[leadId]);
  const profileCode = useSelector((state) => state?.lookup?.profile?.toCode);
  const list = useSelector((state) => state?.lookup?.to);
  const [data, setData] = useState({});

  React.useEffect(() => {
    let code = values?.officeCode || profileCode;
    let name = values?.officeName || list?.filter((e) => e.code === code)?.pop()?.name;
    let bizCode = list?.filter((e) => e.code === code).pop()?.businessCode;
    let allOptions = [
      { value: '', label: 'Chọn...' },
      ...(list?.map((e) => {
        return {
          value: e.code,
          label: e.name,
          businessCode: e.businessCode,
          parent: e.parent,
        };
      }) || []),
    ];

    setData({
      code,
      name,
      bizCode,
      allOptions,
    });
  }, [values, list, profileCode]);

  return data;
};

export default useTO;
